import { defineMessages } from 'react-intl';

/** The copy of the review of today's pitches (design outreach-v2 h1, h2). */
export const reviewMessages = defineMessages({
  title: {
    id: 'app.outreach.reviewToday.title',
    defaultMessage: '{count, plural, one {# pitch waits} other {# pitches wait}} for you',
  },
  titleNone: { id: 'app.outreach.reviewToday.titleNone', defaultMessage: "Today's pitches" },
  crumb: { id: 'app.outreach.reviewToday.crumb', defaultMessage: "Today's pitches" },
  intro: {
    id: 'app.outreach.reviewToday.intro',
    defaultMessage:
      "Approve them and they go in each person's morning. A skipped pitch does not count: Plug writes a new one for another person.",
  },
  skipAll: { id: 'app.outreach.reviewToday.skipAll', defaultMessage: 'Skip all' },
  skipAllConfirm: {
    id: 'app.outreach.reviewToday.skipAllConfirm',
    defaultMessage: 'Skip all {count} pitches? Plug writes new ones for other people.',
  },
  approveAll: { id: 'app.outreach.reviewToday.approveAll', defaultMessage: 'Approve all {count}' },
  approved: { id: 'app.outreach.reviewToday.approved', defaultMessage: 'Approved' },
  skipped: { id: 'app.outreach.reviewToday.skipped', defaultMessage: 'Skipped' },
  check: { id: 'app.outreach.reviewToday.check', defaultMessage: 'Check' },
  autopilotNote: {
    id: 'app.outreach.reviewToday.autopilotNote',
    defaultMessage: 'On autopilot (Ultra) Plug sends the ones that pass its check.',
  },
  never: { id: 'app.outreach.reviewToday.never', defaultMessage: 'Never' },
  neverDone: { id: 'app.outreach.reviewToday.neverDone', defaultMessage: 'Plug never pitches {name} again.' },
  thePitch: { id: 'app.outreach.reviewToday.thePitch', defaultMessage: 'The pitch' },
  angle: { id: 'app.outreach.reviewToday.angle', defaultMessage: 'Angle: {angle}' },
  passes: { id: 'app.outreach.reviewToday.passes', defaultMessage: 'Passes the rules' },
  uses: { id: 'app.outreach.reviewToday.uses', defaultMessage: 'Uses: {facts}' },
  to: { id: 'app.outreach.reviewToday.to', defaultMessage: 'To {name}' },
  position: { id: 'app.outreach.reviewToday.position', defaultMessage: '{index} of {total}' },
  approveNext: { id: 'app.outreach.reviewToday.approveNext', defaultMessage: 'Approve and next' },
  keys: { id: 'app.outreach.reviewToday.keys', defaultMessage: 'Keys: A approve, E edit, S skip' },
  doneTitle: {
    id: 'app.outreach.reviewToday.done.title',
    defaultMessage: "Today's {count, plural, one {# pitch is} other {# pitches are}} approved",
  },
  doneTitleNone: { id: 'app.outreach.reviewToday.done.titleNone', defaultMessage: 'Nothing waits for you' },
  doneBody: {
    id: 'app.outreach.reviewToday.done.body',
    defaultMessage:
      "They go out in each person's morning. Plug writes tomorrow's pitches tonight and tells you at 8:00.",
  },
  openCampaign: { id: 'app.outreach.reviewToday.done.openCampaign', defaultMessage: 'Open the campaign' },
  autopilotOffer: { id: 'app.outreach.reviewToday.done.autopilotOffer', defaultMessage: 'Turn on autopilot on Ultra' },
  autopilotOn: { id: 'app.outreach.reviewToday.done.autopilotOn', defaultMessage: 'Turn on autopilot' },
  failed: { id: 'app.outreach.reviewToday.failed', defaultMessage: 'That did not work. Try again.' },
  words: { id: 'app.outreach.review.words', defaultMessage: '{count, plural, one {# word} other {# words}}' },
  followUp: { id: 'app.outreach.review.followUp', defaultMessage: 'Follow-up' },
  skip: { id: 'app.outreach.review.skip', defaultMessage: 'Skip' },
  edit: { id: 'app.outreach.review.edit', defaultMessage: 'Edit' },
  approve: { id: 'app.outreach.review.approve', defaultMessage: 'Approve' },
  saveApprove: { id: 'app.outreach.review.saveApprove', defaultMessage: 'Save and approve' },
  editing: {
    id: 'app.outreach.review.editing',
    defaultMessage: 'Editing · {count, plural, one {# word} other {# words}}',
  },
  subjectLabel: { id: 'app.outreach.review.subject', defaultMessage: 'Subject' },
  bodyLabel: { id: 'app.outreach.review.body', defaultMessage: 'Pitch' },
  needsEdit: {
    id: 'app.outreach.review.needsEdit',
    defaultMessage: 'Plug could not finish this pitch. Write it yourself or skip it.',
  },
  hintTooShort: {
    id: 'app.outreach.review.hint.tooShort',
    defaultMessage: 'Check: shorter than {min} words. Curators like a full picture.',
  },
  hintTooLong: {
    id: 'app.outreach.review.hint.tooLong',
    defaultMessage: 'Check: longer than {max} words. Curators read short emails.',
  },
  hintTooManyLinks: {
    id: 'app.outreach.review.hint.tooManyLinks',
    defaultMessage: 'Check: more than one link. Keep only the pitch page.',
  },
  hintMoney: {
    id: 'app.outreach.review.hint.money',
    defaultMessage:
      "Blocked: the pitch offers money. Paying for a placement breaks Spotify's rules. Remove it to approve.",
  },
  hintMissingLink: {
    id: 'app.outreach.review.hint.missingLink',
    defaultMessage: 'Blocked: the pitch page link is missing. Add it to approve.',
  },
  hintQuality: { id: 'app.outreach.review.hint.quality', defaultMessage: 'Check: {problem}' },
});
